<div class="user-account-item" [class.user-account-item--active]="isActive">
  <div class="user-account-item__header">
    <div class="user-account-item__title">{{ title || account.label }}</div>

    @if (!isActive) {
      <lib-svg-icon
        class="user-account-item__arrow"
        size="12"
        icon="arrow-right"
      />
    }
  </div>

  <div class="user-account-item__activity-wrapper">
    <div class="user-account-item__btc">
      <span>{{ 'user-accounts.btc' | translate }} </span>
      <span class="user-account-item__btc--amount">{{
        account.amountInBtc | number: '1.0-8'
      }}</span>
    </div>

    <rrp-activity-widget
      class="user-account-item__widget"
      [count]="account.activeWorkers"
    />

    <rrp-activity-widget
      class="user-account-item__widget"
      type="offline"
      [count]="account.offlineWorkers"
    />

    <rrp-activity-widget
      class="user-account-item__widget"
      type="inactive"
      [count]="account.inactiveWorkers"
    />
  </div>
</div>
